import CookieService from "../../services/CookieService";

class TooltipObserver {
  static attach(subscriber, expiry = 360) {
    return new Promise((resolve, reject) => {
      const subscriberElement = document.querySelector(`.${subscriber}`);
      if (!subscriberElement) reject(`subscriber ${subscriber}  is required`);
      const observerObj = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              subscriberElement.style.visibility = "visible";
              CookieService.setCookie(subscriber, true, expiry);
            }
          });
        },
        {
          root: null,
          rootMargin: "0px 0px 0px 0px",
          threshold: 1.0
        }
      );
      observerObj.observe(subscriberElement);
      resolve();
    });
  }
}

export default TooltipObserver;
